import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// MSAL imports
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      // Update the filename in the registration call
      navigator.serviceWorker.register('/custom-sw.js') 
        .then(registration => {
          console.log('Service Worker registered with scope:', registration.scope);
        })
        .catch(error => {
          console.error('Service Worker registration failed:', error);
        });
    });
  }
}

registerServiceWorker();

// Using an async IIFE (Immediately Invoked Function Expression) to handle initialization
(async () => {
    try {
        // 1. Initialize MSAL - this must be called and awaited before anything else
        await msalInstance.initialize();

        // 2. Handle the redirect promise
        const response = await msalInstance.handleRedirectPromise();
        if (response) {
            msalInstance.setActiveAccount(response.account);
        }

        // 3. Set active account if returning to the page
        if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
            msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
        }
    } catch (error) {
        // Log any MSAL initialization or redirect errors
        console.error("MSAL initialization or redirect failed:", error);
    }

    // 4. Render the app after MSAL is ready
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
        <React.StrictMode>
            <MsalProvider instance={msalInstance}>
                <App />
            </MsalProvider>
        </React.StrictMode>
    );
})();

reportWebVitals();
